module.exports = __webpack_public_path__ + "img/COLX.f4a1edbf.svg";